import React from 'react';
import { Button } from './ui/button';
import { COSELLER_MIC_COPY } from '../constants/watchSession';
import type { MicrophoneChoice } from '../hooks/useMicrophoneChoice';

/** A dropdown is sized to its options, never full width (design rule). */
const MIC_PICKER_MAX_WIDTH_CLASS = 'max-w-[320px]';

/**
 * The co-seller's microphone picker in the join step, with the desktop apps'
 * states: "Checking your microphone…" while the browser asks, then the
 * microphones (or "No microphones found") with Refresh. Nothing when access
 * was refused: the step says why above.
 */
const MicrophonePicker: React.FC<{ choice: MicrophoneChoice }> = ({ choice }) => {
  const { microphoneState, microphones, selectedDeviceId, selectMicrophone, refresh } = choice;

  if (microphoneState === 'checking') {
    return <p className="text-[12px] text-ink-muted mt-2">{COSELLER_MIC_COPY.checkingMicrophone}</p>;
  }
  if (microphoneState !== 'ready') return null;

  return (
    <div className="mt-2">
      <span className="block text-[11px] font-semibold text-ink-muted mb-1">{COSELLER_MIC_COPY.microphone}</span>
      <div className="flex items-center gap-2">
        {microphones.length > 0 ? (
          <select
            aria-label={COSELLER_MIC_COPY.microphone}
            value={selectedDeviceId}
            onChange={(event) => selectMicrophone(event.target.value)}
            className={`w-auto ${MIC_PICKER_MAX_WIDTH_CLASS} text-sm px-2 py-1 border border-ink-border rounded focus:ring-2 focus:ring-signature focus:border-signature`}
          >
            {microphones.map((microphone) => (
              <option key={microphone.deviceId || microphone.label} value={microphone.deviceId}>
                {microphone.label}
              </option>
            ))}
          </select>
        ) : (
          <span className="text-[12px] text-ink-muted">{COSELLER_MIC_COPY.noMicrophones}</span>
        )}
        <Button variant="tertiary" size="sm" onClick={refresh} className="text-xs">
          {COSELLER_MIC_COPY.refreshMicrophones}
        </Button>
      </div>
    </div>
  );
};

export default MicrophonePicker;
